export default "__VITE_ASSET__64e95ae8__"